/*Views*/
import UserManagement from '../components/views/userManagement.vue'
import DeviceManagement from '../components/views/deviceManagement.vue'
import WebhookConfiguration from '../components/views/webHooks.vue'
import HealthCheck from '../components/views/healthCheck.vue'
import Login from '../components/views/login.vue'
import AccountCreation from '../components/views/internal/accountCreation.vue'
import AccountDetails from '../components/views/accountDetails.vue'
import GroupManagement from '../components/views/groupManagement.vue'
import AuthenticatorManagement from '../components/views/authenticatorManagement.vue'
import DeviceAlarmSettings from '../components/views/deviceAlarmSettings.vue'
import PhysicalAccessLogs from '../components/views/physicalAccessLogs.vue'
import ReleaseNotes from '../components/views/releaseNotes.vue'

const routes = [
  {path: '/', redirect: {name: 'users'}},
  {
    name: 'login',
    path: '/login/:mode?',
    component: Login,
    props: (route) => {
      return {
        query: route.query.device,
        mode: route.params.mode,
        resetToken: route.query.resetToken,
      }
    },
    meta: {
      route_title: 'Link Manager',
      bypassLogin: true,
    },
  },
  {
    name: 'users',
    path: '/users',
    component: UserManagement,
    meta: {
      route_title: 'User Management',
    },
  },
  {
    name: 'devices',
    path: '/devices',
    component: DeviceManagement,
    props: true,
    meta: {
      route_title: 'Device Management',
    },
  },
  {
    name: 'configuration',
    path: '/configuration',
    redirect: '/configuration/authenticators',
    meta: {
      route_title: 'Configuration',
      authorizationResource: 'configuration',
    },
  },
  {
    name: 'authenticators',
    path: '/configuration/authenticators',
    components: {
      default: AuthenticatorManagement,
    },
    meta: {
      route_title: 'Configuration: Authenticators',
      authorizationResource: 'configuration',
    },
  },
  {
    name: 'alarm',
    path: '/configuration/alarm',
    components: {
      default: DeviceAlarmSettings,
    },
    meta: {
      route_title: 'Configuration: Alarm Settings',
      authorizationResource: 'configuration',
    },
  },
  {
    name: 'webhooks',
    path: '/configuration/webhooks',
    components: {
      default: WebhookConfiguration,
    },
    meta: {
      route_title: 'Configuration: Webhooks',
      authorizationResource: 'configuration',
    },
  },
  {
    name: 'status',
    path: '/status',
    component: HealthCheck,
    meta: {
      bypassLogin: true,
    },
  },
  {
    name: 'internal',
    path: '/internal',
    component: AccountCreation,
    meta: {
      bypassLogin: true,
    },
  },
  {
    name: 'accountDetails',
    path: '/account',
    component: AccountDetails,
  },
  {
    name: 'groups',
    path: '/groups',
    component: GroupManagement,
    meta: {
      route_title: 'Group Management',
    },
  },
  {
    name: 'accessLogs',
    path: '/access-logs',
    component: PhysicalAccessLogs,
    meta: {
      route_title: 'Physical Access Logs',
    },
  },
  {
    name: 'releaseNotes',
    path: '/release-notes',
    component: ReleaseNotes,
    meta: {
      route_title: 'Release Notes',
      bypassLogin: true,
    },
  },
]

export default routes
